<template>
    <div class="mb-0 bg-dark bg-header">
        <nav class="navbar navbar-expand-sm nav-bg" v-bind:class="{ 'bg-dark navbar-dark': !hasBreadCrumbs, 'navbar-dark': hasBreadCrumbs }">

            <router-link class="navbar-brand" to="/">
                <img :src="'https://fabricfour.blob.core.windows.net/mhslearning-upload/' + this.siteDesign.navigation.logoFileName" alt="images" style="height: 80px">
            </router-link>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">

                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == '') }">
                        <router-link class="nav-link nav-tx" to="/">Home</router-link>
                    </li>

                    <li class="nav-item" v-if="isAuthenticated" v-bind:class="{ 'active': (currentPageName == 'Dashboard') }">
                        <router-link class="nav-link nav-tx" to="/dashboard">My Profile</router-link>
                    </li>

                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == 'Courses') }">
                        <router-link class="nav-link nav-tx" to="/courses">Browse Courses</router-link>
                    </li>

                    <li class="nav-item" v-if="this.siteDesign.paygateId" v-bind:class="{ 'active': (currentPageName == 'Cart') }">
                        <router-link class="nav-link nav-tx" to="/cart">Cart <span v-if="cart.length" class="accent-secondary-tx">({{cart.length}})</span></router-link>
                    </li>

                    <li class="nav-item" v-if="isAuthenticated">
                        <a class="nav-link nav-tx" v-on:click="logout">Log Out</a>
                    </li>

                    <li class="nav-item" v-if="!isAuthenticated && siteDesign && !useExternalAuthProvider">
                        <router-link class="nav-link nav-tx" to="/auth/register">Register</router-link>
                    </li>

                    <li class="nav-item" v-if="!isAuthenticated">
                        <router-link class="nav-link nav-tx" to="/auth/login">Sign In</router-link>
                    </li>
                </ul>
            </div>
        </nav>
        <div v-if="hasBreadCrumbs" class="flat-header-blog">
            <div class="page-title page-title-blog">
                <div class="page-title-inner">
                    <div class="breadcrumbs breadcrumbs-blog text-left">
                        <div class="container">
                            <div class="breadcrumbs-wrap">
                                <ul class="breadcrumbs-inner">
                                    <li>
                                        <router-link to="/">Home</router-link>
                                    </li>

                                    <li v-for="(key, val) in breadCrumbs">
                                        <router-link :to="val">{{ key }}</router-link>
                                    </li>
                                </ul>
                                <div class="title">
                                    {{ currentPageName }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .nav-link {
        font-size: 18px;
        cursor: pointer;
    }

    @media only screen and (max-width: 720px) {
        .nav-link {
            font-size: 13px;
        }
    }
</style>

<script>

    export default {
        name: 'HeaderComponent',
        data() {
            return {
                backgroundImageFileName: null,
            }
        },
        methods: {
            logout: function () {
                this.$store.commit("setUserState", null);

                if (this.$route.path !== "/") {
                    this.$router.push("/");
                }
            }
        },
        computed: {
            breadCrumbs() {
                return this.$store.state.breadCrumbs;
            },
            hasBreadCrumbs() {
                var breadCrumbs = this.$store.state.breadCrumbs;
                return breadCrumbs && Object.keys(breadCrumbs).length > 0;
            },
            currentPageName() {

                if (this.breadCrumbs == null)
                    return "";

                var keys = Object.keys(this.breadCrumbs);
                var lastKey = keys[keys.length - 1];
                var lastName = this.breadCrumbs[lastKey];

                return lastName;
            },
            isAuthenticated() {
                return this.$store.state.isAuthenticated
            },
            cart() {
                return this.$store.state.cart
            },
            siteDesign() {
                return this.$store.getters.getSiteDesign;
            },
            useExternalAuthProvider() {
                return !!this.siteDesign?.useExternalAuthProvider;
            }
        },
        async mounted() {
        }
    }
</script> 